import React from "react";

const NoFavourites = ({ ...r }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 180 197" { ...r }>
      <g filter="url(#no-favourites-a)">
        <path
          fill="#FEFEFE"
          d="M8 12.5a8 8 0 018-8h148a8 8 0 018 8v72a8 8 0 01-8 8H16a8 8 0 01-8-8v-72z"
        ></path>
        <rect
          width="40"
          height="28"
          x="16"
          y="34.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="12.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="36"
          x="64"
          y="24.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="64.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="76.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <path
          fill="#FDB727"
          d="M153.404 48.904l3.888 3.888a1 1 0 001.415-.002l3.883-3.893a3.252 3.252 0 00-2.35-5.364 3.25 3.25 0 00-2.24.787 3.249 3.249 0 00-4.419.164 3.266 3.266 0 00-.177 4.42z"
        ></path>
      </g>
      <g filter="url(no-favourites-b)">
        <path
          fill="#FEFEFE"
          d="M8 104.5a8 8 0 018-8h148a8 8 0 018 8v72a8 8 0 01-8 8H16a8 8 0 01-8-8v-72z"
        ></path>
        <rect
          width="40"
          height="28"
          x="16"
          y="126.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="104.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="36"
          x="64"
          y="116.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="156.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <rect
          width="80"
          height="8"
          x="64"
          y="168.5"
          fill="#F2F2F2"
          rx="2"
        ></rect>
        <path
          fill="#FDB727"
          d="M153.404 140.904l3.888 3.888c.391.39 1.025.39 1.415-.001l3.883-3.894a3.254 3.254 0 00-.172-4.417 3.252 3.252 0 00-4.418-.16 3.248 3.248 0 00-4.419.164 3.266 3.266 0 00-.177 4.42z"
        ></path>
      </g>
      <defs>
        <filter
          id="no-favourites-a"
          width="180"
          height="104"
          x="0"
          y="0.5"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="4"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7730_10692"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_7730_10692"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="no-favourites-b"
          width="180"
          height="104"
          x="0"
          y="92.5"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="4"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7730_10692"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_7730_10692"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default NoFavourites;